if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
  // --- 1. Start loading state safely ---
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  const spinner = opener.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden');

  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

      // --- 2. Find the "main product root" in ANY template ---

      // a) First try anything whose id starts with MainProduct- (works for Dawn and your <product-info>)
      this.productElement =
        responseHTML.querySelector('[id^="MainProduct-"]') ||
        // b) Fallback: any element that looks like a product section
        responseHTML.querySelector('[data-section][class*="product"]');

      if (!this.productElement) {
        console.error(
          'Quick add: product root not found in fetched HTML for',
          opener.getAttribute('data-product-url')
        );
        return; // Stop here, don't try to work with null
      }

      // --- 3. Copy color / gradient classes from product root onto modal container ---
      this.productElement.classList.forEach((classApplied) => {
        if (classApplied.startsWith('color-') || classApplied === 'gradient') {
          this.modalContent.classList.add(classApplied);
        }
      });

      // --- 4. Normalize IDs and prep HTML ---
      this.preventDuplicatedIDs();
      this.removeDOMElements();
      this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

      // --- 5. Re-init Shopify stuff inside modal ---
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      this.removeGalleryListSemantic();
      this.updateImageSizes();
      this.preventVariantURLSwitching();

      // --- 6. Finally open modal ---
      super.show(opener);
    })
    .catch((error) => {
      console.error('Quick add fetch error', error);
    })
    .finally(() => {
      // --- 7. Always clean up loading state safely ---
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      const spinner = opener.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
}


      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
  const sectionId = this.productElement.dataset.section;
  if (!sectionId) return; // nothing to replace

  this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
    sectionId,
    `quickadd-${sectionId}`
  );

  this.productElement
    .querySelectorAll('variant-selects, variant-radios, product-info')
    .forEach((element) => {
      element.dataset.originalSection = sectionId;
    });
}



      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
  // If modal content does not exist yet, bail out
  if (!this.modalContent) return;

  // Classic Dawn templates wrap the main product in .product.
  // PagePilot templates do NOT, so product will be null there.
  const product = this.modalContent.querySelector('.product');
  if (!product) return; // <-- critical line

  const desktopColumns = product.classList.contains('product--columns');
  if (!desktopColumns) return;

  const mediaImages = product.querySelectorAll('.product__media img');
  if (!mediaImages.length) return;

  let mediaImageSizes =
    '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

  if (product.classList.contains('product--medium')) {
    mediaImageSizes = mediaImageSizes.replace('715px', '605px');
  } else if (product.classList.contains('product--small')) {
    mediaImageSizes = mediaImageSizes.replace('715px', '495px');
  }

  mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
}
    }
  );
}
